<template>
  <div class="skills">
    <span
      v-for="(skill, i) in skills"
      :key="i"
      :class="classes(i, skill)"
      @click="addSkillToSearch(skill)"
    >
      {{ skill.name ? skill.name : skill }}
    </span>
    <span
      v-if="skillList.length > 5 && skillsShown <= 5 && (max < 0 || max > 5)"
      :class="[{ pointer: interactive }, itemClass]"
      @click="showAllSkills(skillList.length)"
    >
      {{ showMore }}
    </span>
  </div>
</template>

<script>
import { FILTER_MUTATIONS } from '@/state/mutation-types'

export default {
  name: 'ProfileSkillsVue',
  props: {
    skillList: {
      type: Array,
      required: true,
    },
    max: {
      type: Number,
      required: false,
      default: -1,
    },
    interactive: {
      type: Boolean,
      required: false,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: true,
    },
    itemClass: {
      type: String,
      required: false,
      default: null,
    },
    showMoreLabel: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      skillsShown: 5,
    }
  },
  computed: {
    skills() {
      return this.skillList.slice(0, this.skillsShown)
    },
    showMore() {
      return (
        this.showMoreLabel ??
        `+ ${$t(':count more', {
          count: this.skillList.length - this.skillsShown,
        })}`
      )
    },
  },
  created() {
    if (this.max >= 0 && this.max < 5) {
      this.skillsShown = this.max
    }
  },
  methods: {
    showAllSkills(numSkills) {
      if (this.max < 0) {
        this.skillsShown = numSkills
      } else {
        this.skillsShown = this.max
      }
    },
    addSkillToSearch(skill) {
      if (!this.interactive) return
      if (!this.filter.search.term.includes(skill.name)) {
        this.$store.commit(
          FILTER_MUTATIONS.SET_SEARCH_TERM,
          `${this.$store.state.filter.search.term},${skill.name}`,
        )
      }
    },
    classes(i, skill) {
      if (this.itemClass) {
        return this.itemClass
      }

      return {
        'bgm-indigo': skill.is_keyword,
        label: true,
        pointer: this.interactive,
        'label-default': i <= 2,
        'bgm-purple': i <= 2 && !skill.is_keyword,
        'label-basic': i > 2 && !skill.is_keyword,
      }
    },
  },
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.skills {
  overflow: auto;
}
</style>
